module.exports = __webpack_public_path__ + "img/career-fair.3f5d9c16.svg";